import { render, staticRenderFns } from "./RoleGuard.vue?vue&type=template&id=9a4cfe5a&lang=pug"
import script from "./RoleGuard.vue?vue&type=script&lang=js"
export * from "./RoleGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports